import { IComboSlot, IComboSlotOption, IItem } from '@rbi-ctg/menu';
import { ProductWizardStep, UserSelectionModifierSlotMap } from 'state/product-wizard-v2/types';

import { ComboSlotType } from '../ComboSlotType';
import { DefaultModifiersMap, SelectModifierFn } from '../types';

export interface IProductCustomizationDrinks {
  slotKeyToCustomize: string;
  comboSlotType: ComboSlotType;
  comboSlot: IComboSlot | null | undefined;
  comboSlotOptions: IComboSlotOption[];
  currentStep: ProductWizardStep;
  selectedItem: IItem | null;
  handleComboSlotSelectionChange: (comboSlotOption: IComboSlotOption) => void;
  modifierSelections: UserSelectionModifierSlotMap;
  defaultModifiersMap: DefaultModifiersMap;
  handleChangeModifierSelections: SelectModifierFn;
  handleResetModifierSelections: () => void;
  pickerAspectExclusions: Set<string> | undefined;
  onPressBackNavigation: () => void;
  backNavigationLabel?: string;
}

export enum DrinksCategories {
  FROZENS = 'FROZENS',
  OTHERS = 'OTHERS',
  SHAKES = 'SHAKES',
  SOFT_DRINKS = 'SOFT_DRINKS',
}

export type DrinkCategoriesKeys = keyof typeof DrinksCategories;
export type DrinksCategorizedOptions = Record<DrinkCategoriesKeys, IComboSlotOption[]>;
